/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({

    AccountHolderLabel: {
        id: 'qnb.common.sgMonthlyDdi.AccountHolderLabel',
        defaultMessage: 'Name of account holder'
    },
    AccountNumberLabel: {
        id: 'qnb.common.sgMonthlyDdi.AccountNumberLabel',
        defaultMessage: 'Account number'
    },
    SortCodeLabel: {
        id: 'qnb.common.sgMonthlyDdi.SortCodeLabel',
        defaultMessage: 'Sort Code'
    },
    WhereWouldIFoundThis: {
        id: 'qnb.common.sgMonthlyDdi.WhereWouldIFoundThis',
        defaultMessage: 'Where would I find this?'
    },
    AccountNumberHelptextP1: {
        id: 'qnb.common.sqMonthlyDdi.AccountNumberHelptextP1',
        defaultMessage: 'Normally eight digits long, the account number can be found on the front of most debit cards (e.g. 10203040). '
            + 'You could also check your statement, cheque book or online banking.'
    },
    AccountNumberHelptextP2: {
        id: 'qnb.common.sqMonthlyDdi.AccountNumberHelptextP2',
        defaultMessage: 'If your account number is only seven digits, please add a zero at the beginning.'
    },
    SortCodeHelptextP1: {
        id: 'qnb.common.sgMonthlyDdi.SortCodeHelptextP1',
        defaultMessage: 'Shown as three sets of two digits (e.g. 10-20-30), the sort code is found on the front of most debit cards.'
    },
    SortCodeHelptextP2: {
        id: 'qnb.common.sgMonthlyDdi.SortCodeHelptextP2',
        defaultMessage: 'You could also check your statement, cheque book or online banking.'
    },
    DirectDebitText: {
        id: 'qnb.common.sgMonthlyDdi.DirectDebitText',
        defaultMessage: 'By submitting this Direct Debit request, you confirm that you are a named account holder with the authority to set up Direct Debits. If you are not authorised to set up Direct Debit payments, please phone us on {phoneNumber} to discuss. Your payments will be debited from your account within 14 days, or on your cover start date, whichever is later. You can change your regular Direct Debit collection date by calling us after your first payment has been collected. A full payment schedule will be included within your policy documents, your policy will renew annually until you notify us otherwise.'
    },
    DirectDebitHeading: {
        id: 'qnb.common.sgMonthlyDdi.DirectDebitHeading',
        defaultMessage: 'Your Direct Debit details'
    }
});
